// extracted by mini-css-extract-plugin
module.exports = {"ActiveButton":"styles_ActiveButton__pyvLK","DeactiveButton":"styles_DeactiveButton__ZLwfu"};